'use strict';

/**
 * Chat wallpaper picker grid.
 *
 * Mounted inside the chatwallpaper dialog. Handles selection, and either saves the
 * selection (premium) or routes to the PA promo overlay (non-premium).
 */
export class Chatwallpaper {
	constructor(component_key) {
		this.id = component_key;
		this.component = yalwa.v.components[component_key];
		this.block = this.component.component_type;
		this.$root = jQuery(`.js-${this.id}`);
		this.selectedID = parseInt(this.component.selected_id, 10) || 0;
		this.isPremium = !!this.component.is_premium;
	}

	init() {
		this.add_events();
		this.update_cta();
	}

	add_events() {
		// One namespace per binding, as on_once() removes only its own event string.
		this.$root.on_once('click.wallpaper_item', `.js-${this.block}_item`, (e) => {
			this.select(jQuery(e.currentTarget));
		});

		this.$root.on_once('click.wallpaper_save', `.js-${this.block}_save`, () => {
			this.save();
		});

		// The learn CTA opens the MC benefits PLP. It is bound here rather than left to the
		// PLP dialog's own trigger list: this grid is fetched lazily with the wallpaper
		// dialog, so the PLP's page-load trigger binding never sees it.
		this.$root.on_once('click.wallpaper_learn', `.js-${this.block}_learn`, () => {
			this.open_plp();
		});
	}

	open_plp() {
		const plp = (yalwa.v.component_instances || {})['dialog_mcbenefitsplp'];
		if (!plp) {
			return;
		}
		// Pass the touchpoint so the PLP reports this open as the wallpaper CTA, not as an
		// unattributed one.
		plp.show('wallpaper');
	}

	select($item) {
		this.selectedID = parseInt($item.data('wallpaper_id'), 10) || 0;

		const item_class = `${this.block}__item--selected`;
		this.$root.find(`.js-${this.block}_item`).each((_, el) => {
			jQuery(el).removeClass(item_class).attr('aria-pressed', 'false');
		});
		$item.addClass(item_class).attr('aria-pressed', 'true');

		this.update_cta();
	}

	update_cta() {
		if (!this.isPremium) {
			return;
		}
		const current = parseInt(this.component.selected_id, 10) || 0;
		this.set_save_disabled(this.selectedID === current);
	}

	// ywc web components reflect `disabled` as an attribute, not a DOM property.
	set_save_disabled(disabled) {
		const $save = this.$root.find(`.js-${this.block}_save`);
		if (disabled) {
			$save.attr('disabled', 'disabled');
		} else {
			$save.removeAttr('disabled');
		}
	}

	save() {
		if (!this.selectedID) {
			return;
		}
		const $save = this.$root.find(`.js-${this.block}_save`);
		this.set_save_disabled(true);

		jQuery.ajax({
			url: '/api/ajax/chat/',
			type: 'post',
			dataType: 'json',
			data: {
				action: 'save_chat_wallpaper',
				wallpaper_id: this.selectedID,
				touchpoint: this.component.touchpoint,
				csrf_bust: this.component.csrf,
			},
		}).done((json) => {
			if (json && json.success) {
				this.component.selected_id = this.selectedID;
				this.apply_wallpaper();
				this.close_dialog();
				yalwa.basics.toast({message: json.label, type: json.type});
			} else {
				this.set_save_disabled(false);
				if (json && json.label) {
					yalwa.basics.toast({message: json.label, type: json.type});
				}
			}
		}).fail(() => {
			this.set_save_disabled(false);
		});
	}

	close_dialog() {
		const instance = (yalwa.v.component_instances || {})['dialog_' + this.block];
		if (instance && typeof instance.hide === 'function') {
			instance.hide();
		}
	}

	apply_wallpaper() {
		// Update the client-side globals so subsequent chat loads keep the new wallpaper.
		const entry = this.component.catalog[this.selectedID];
		if (!entry) {
			return;
		}
		yalwa.v.chat_wallpaper_type = entry.type;
		yalwa.v.chat_wallpaper_value = entry.background;
		yalwa.v.chat_wallpaper_theme = parseInt(entry.block_theme, 10) === 2 ? 'on_dark' : 'on_light';
		if (yalwa.chat && typeof yalwa.chat.apply_chat_wallpaper === 'function') {
			yalwa.chat.apply_chat_wallpaper();
		}
	}
}